import {Form} from './form';
import {DynamicSubscriptionView} from '../view/dynamic-subscription-view';
import {Config} from '../config';
import {currencySymbols} from '../config/currency-symbols';

export class DynamicSubscriptionForm extends Form {

    view: DynamicSubscriptionView = new DynamicSubscriptionView();
    dynamicPlanInterval: any;
    constructor() {
        super();
    }
    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);
        return Promise.resolve();
    }
    async render() {
        await this.view.dynamicSubscriptionRender(currencySymbols[this.config.settings.currency], this.paymentData.amount);
        const inputAmount = document.getElementById('amount') as HTMLInputElement;
        inputAmount.oninput = () => {
            this.paymentData.amount = +inputAmount.value;
            this.triggerEvent('amountChange');
        };
    }
    submit() {
        this.dynamicPlanInterval = this.view.getSubscriptionPlan();
        const planMenu = document.getElementById('dynamic-plan-interval') as HTMLSelectElement;
        const dynamicPlanInterval = planMenu.options[planMenu.selectedIndex].value;
        return Promise.resolve({
            dynamicPlanInterval : dynamicPlanInterval,
            selectedProducts : [{amount: this.paymentData.amount}]
        });
    }

}
